import styled from 'styled-components';

export const H1 = styled.h1`
  color: ${p => p.theme.color.textDefault};
  font-family: ${p => p.theme.font.primary};
  font-size: 24px;
`;

export const H2 = styled.h2`
  color: ${p => p.theme.color.textDefault};
  font-family: ${p => p.theme.font.primary};
  font-size: 20px;
`;

export const H3 = styled.h3`
  color: ${p => p.theme.color.textDefault};
  font-family: ${p => p.theme.font.primary};
  font-size: 16px;
`;

export const Label = styled.label`
  color: ${p => p.theme.color.textDefault};
  display: block;
  font-family: ${p => p.theme.font.primary};
  font-size: 12px;
  line-height: 1.25;
  letter-spacing: 0.1px;
  margin: ${p => p.margin || 0} 0;
`;

export const ListItem = styled.p`
  color: ${p => p.theme.color.textDefault};
  font-family: ${p => p.theme.font.primary};
  font-size: 16px;
  line-height: 20px;
  margin-bottom: 20px;
`;



// WEBPACK FOOTER //
// ./src/components/typography.js